import React from 'react'
import   { EdgeText } from 'react-flow-renderer';
import nerdamer from'nerdamer/nerdamer.core'
import 'nerdamer/Algebra'
import 'nerdamer/Calculus'
import 'nerdamer/Solve'
import { Bezier } from "bezier-js";

function CustomEdgeDown({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    data,
  }) {

    const refxStart = 5;
    const refyStart = 5;
    const refxEnd = 5;
    const refyEnd = 5;
    let tempSourceX = sourceX;
    let tempSourceY = sourceY;
    let tempTargetX = targetX;
    let tempTargetY= targetY;

    let controlX = 0;
    let controlY = 0;
    let edgePath1 = '';
    let edgePath2 = '';


    if(data.positionStart !== undefined){
      
      if(data.positionStart === 'bottom'){
        tempSourceY += data.nodesHeight;
      }
      else if(data.positionStart === 'left'){
        tempSourceY += data.nodesHeight/2;
        tempSourceX -= data.nodesWidth/2;
        
      }
      else if(data.positionStart === 'right'){
        tempSourceY += data.nodesHeight/2;
        tempSourceX += data.nodesWidth/2
      }
      
      
      if(data.positionTarget === 'bottom'){
        tempTargetY += data.nodesHeight;
      }
      else if(data.positionTarget === 'left'){
        tempTargetY += data.nodesHeight/2;
        tempTargetX -= data.nodesWidth/2;
      }
      else if(data.positionTarget === 'right'){
        tempTargetY += data.nodesHeight/2;
        tempTargetX += data.nodesWidth/2
      }
      
      
      
      if(Math.abs(tempTargetX - tempSourceX) > 0.01){

        const alpha = (tempTargetY - tempSourceY) / (tempTargetX - tempSourceX);
        const beta =  tempTargetY - alpha * tempTargetX;
        const xMiddle = tempSourceX  +  (tempTargetX - tempSourceX )/2;
        const yMiddle = alpha * xMiddle + beta; 
        
        if(Math.abs(alpha) > 0.01 ){
          const newAlpha = -1/ alpha;
          const newBeta = yMiddle - newAlpha * xMiddle;

          const x = nerdamer.solveEquations( [`${data.distance*data.distance}= (x-${xMiddle})^2+ (y-${yMiddle})^2`, `y=${newAlpha}*x+${newBeta}`])
          
          controlX =  -x[0][1] + 2*xMiddle;
          controlY  = newAlpha * controlX + newBeta

        }
        else{
          controlX = tempSourceX + (tempTargetX - tempSourceX)/2
          controlY = tempSourceY - data.distance

        }
        
      }
      else{

        controlX = tempSourceX + data.distance;
        controlY = tempSourceY +  ( tempTargetY - tempSourceY)/2;
      }

      const curve = new Bezier(tempSourceX,tempSourceY , controlX,controlY , tempTargetX, tempTargetY);
      const segmentCurve1 = curve.split(0, 0.5);
      const segmentPoints1 = segmentCurve1.points

      const segmentCurve2 = curve.split(0.5, 1);
      const segmentPoints2 = segmentCurve2.points;

      edgePath1 = `M${segmentPoints1[0].x},${segmentPoints1[0].y} Q${segmentPoints1[1].x},${segmentPoints1[1].y} ${segmentPoints1[2].x},${segmentPoints1[2].y}`;
      edgePath2 = `M${segmentPoints2[0].x},${segmentPoints2[0].y} Q${segmentPoints2[1].x},${segmentPoints2[1].y} ${segmentPoints2[2].x},${segmentPoints2[2].y}`;
    }  
    const [hoverState, setHoverState] = React.useState(false);
  
    const mouseLeave = () => {
      setTimeout(() => {
        setHoverState(false)  
      }, data.isService !== undefined ? 1000 : 500);
      
    }
  
    const mouseOver = () => {
      setHoverState(true)
    }
    
    const returnLabelBgStyle = () => {
      if(hoverState === false){
        return {fillOpacity: '0'};
      }
      if(data.isHref !== undefined){
        return {fill: 'green', color: 'green', fillOpacity: '1'};
      }
      if(data.isService !== undefined ){
        return {fill: 'purple',color : 'purple',fillOpacity: '1'};
      }
      return { fill: '#E83C52', color: '#E83C52', fillOpacity: '1'}

    }

    return (
      <>
        <marker id="markerArrow"  markerWidth="13" markerHeight="13" refX="2" refY="6" orient="auto">
          <path d="M2,2 L2,11 L10,6 L2,2" />
        </marker>
        <marker id="dotStart" markerWidth="5" markerHeight="5" viewBox="0 0 10 10" refX= {refxStart} refY= {refyStart}>
          <circle cx="5" cy="5" r="5" fill="black" />
        </marker>
        <marker id="dotEnd" markerWidth="5" markerHeight="5" viewBox="0 0 10 10" refX={refxEnd} refY={refyEnd}>
          <circle cx="5" cy="5" r="5" fill="black" />
        </marker>
        <path onMouseOver={() => mouseOver()} onMouseLeave={() => mouseLeave()} id={id} style={{stroke: data.stroke}} className="react-flow__edge-path" d={edgePath2} markerEnd="url(#dotEnd)"/>
        <path onMouseOver={() => mouseOver()} onMouseLeave={() => mouseLeave()} id={id} style={{stroke: data.stroke}} className="react-flow__edge-path" d={edgePath1} markerStart="url(#dotStart)" markerEnd="url(#markerArrow)"/>
        <EdgeText
          x={1/3 *(tempTargetX + tempSourceX + controlX)}
          y={1/3 *(tempTargetY + tempSourceY + controlY)}
          label={data.text}
          labelStyle={ hoverState? { fill: '#fff',  fillOpacity: '1' }: {fill:'#fff', fillOpacity: '0'}}        
          labelBgStyle={ returnLabelBgStyle()}
          labelBgPadding={[2, 4]}
          labelBgBorderRadius={2}
        />
      </>
    );
  }
  
 

  function CustomEdgeUp({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    data,
  }) {
    
    const refxStart = 5;
    const refyStart = 5;
    const refxEnd = 5;
    const refyEnd = 5;
    let tempSourceX = sourceX;
    let tempSourceY = sourceY;
    let tempTargetX = targetX;
    let tempTargetY = targetY;

    let controlX = 0;
    let controlY = 0;

    let edgePath1 = '';
    let edgePath2 = '';

    if(data.positionStart !== undefined && data.nodesWidth !== null){
      
      if(data.positionStart === 'bottom'){
        tempSourceY += data.nodesHeight;
      }
      else if(data.positionStart === 'left'){
        tempSourceY += data.nodesHeight/2;
        tempSourceX -= data.nodesWidth/2;
      }
      else if(data.positionStart === 'right'){
        tempSourceY += data.nodesHeight/2;
        tempSourceX += data.nodesWidth/2
      }
     

      if(data.positionTarget === 'bottom'){
        tempTargetY += data.nodesHeight;
      }
      else if(data.positionTarget === 'left'){
        tempTargetY += data.nodesHeight/2;
        tempTargetX -= data.nodesWidth/2;
      }
      else if(data.positionTarget === 'right'){
        tempTargetY += data.nodesHeight/2;
        tempTargetX += data.nodesWidth/2
      }
      
      if(Math.abs(tempTargetX - tempSourceX) > 0.01){
        const alpha = (tempTargetY - tempSourceY) / (tempTargetX - tempSourceX);
        const beta =  tempTargetY - alpha * tempTargetX;
        const xMiddle = tempSourceX  +  (tempTargetX - tempSourceX )/2;
        const yMiddle = alpha * xMiddle + beta; 
      
        if(Math.abs(alpha) > 0.01 ){
          const newAlpha = -1/ alpha;
          const newBeta = yMiddle - newAlpha * xMiddle;

          const x = nerdamer.solveEquations( [`${data.distance*data.distance}= (x-${xMiddle})^2+ (y-${yMiddle})^2`, `y=${newAlpha}*x+${newBeta}`])
          const [tempControl0, tempControl1] = x;
          const [, tempControl01] = tempControl0;
          const [, tempControl11] = tempControl1;
          controlX = tempControl01;
          controlY = tempControl11; 
        }
        else{
          controlX = tempSourceX + (tempTargetX - tempSourceX)/2
          controlY = tempSourceY + data.distance
        }
      }else{

        controlX = tempSourceX + data.distance;
        controlY = tempSourceY + (tempTargetY - tempSourceY)/2;
      }
      

      const curve = new Bezier(tempSourceX,tempSourceY , controlX,controlY , tempTargetX,tempTargetY);
      const segmentCurve1 = curve.split(0, 0.5);
      const segmentPoints1 = segmentCurve1.points

      const segmentCurve2 = curve.split(0.5, 1);
      const segmentPoints2 = segmentCurve2.points;

      edgePath1 = `M${segmentPoints1[0].x},${segmentPoints1[0].y} Q${segmentPoints1[1].x},${segmentPoints1[1].y} ${segmentPoints1[2].x},${segmentPoints1[2].y}`;
      edgePath2 = `M${segmentPoints2[0].x},${segmentPoints2[0].y} Q${segmentPoints2[1].x},${segmentPoints2[1].y} ${segmentPoints2[2].x},${segmentPoints2[2].y}`;
    
    }
    const [hoverState, setHoverState] = React.useState(false);
  
    const mouseLeave = () => {
      setTimeout(() => {
        setHoverState(false)  
      }, 500);
      
    }
  
    const mouseOver = () => {
      setHoverState(true)
    }
  
    const returnLabelBgStyle = () => {
      if(hoverState === false){
        return {fillOpacity: '0'};
      }
      if(data.isHref !== undefined){
        return {fill: 'green', color: 'green', fillOpacity: '1'}
      }
      if(data.isService !== undefined){
        return { fill: 'purple',color : 'purple',fillOpacity: '1'}
      }
      return { fill: '#E83C52', color: '#E83C52', fillOpacity: '1'};
    }

    return (
      < >
        <marker id="markerArrow" markerWidth="13" markerHeight="13" refX="2" refY="6" orient="auto">
          <path d="M2,2 L2,11 L10,6 L2,2" />
        </marker>
        <marker id="dotStart" markerWidth="5" markerHeight="5" viewBox="0 0 10 10" refX= {refxStart} refY= {refyStart}>
          <circle cx="5" cy="5" r="5" fill="black" />
        </marker>
        <marker id="dotEnd" markerWidth="5" markerHeight="5" viewBox="0 0 10 10" refX= {refxEnd} refY= {refyEnd}>
          <circle cx="5" cy="5" r="5" fill="black" />
        </marker>
        <path onMouseOver={() => mouseOver()} onMouseLeave={() => mouseLeave()} id={id} style={{stroke: data.stroke}} className="react-flow__edge-path" d={edgePath2} markerEnd = "url(#dotEnd)"/>
        <path onMouseOver={() => mouseOver()} onMouseLeave={() => mouseLeave()} id={id} style={{stroke: data.stroke}} className="react-flow__edge-path" d={edgePath1} markerStart= "url(#dotStart)" markerEnd="url(#markerArrow)"/>
        <EdgeText
          x={1/3 *(tempTargetX + tempSourceX + controlX)}
          y={1/3 *(tempTargetY + tempSourceY + controlY)}
          label={data.text}
          labelStyle={ hoverState? { fill: '#fff',  fillOpacity: '1' }: {fill:'#fff', fillOpacity: '0'}}        
          labelBgStyle={returnLabelBgStyle()}
          labelBgPadding={[2, 4]}
          labelBgBorderRadius={2}
        />
      </>
    );
  }

  export {
    CustomEdgeUp,
    CustomEdgeDown
  }